import { Controller } from "@hotwired/stimulus";

// GTM Form Submission triggers can cancel the original submit and later call
// form.submit(). That programmatic call ignores the clicked button's formaction,
// so every option posts to the form's default action. Copy each native submit's
// submitter formaction onto the form before GTM handles the submission.
export default class extends Controller<HTMLFormElement> {
  select(event: SubmitEvent) {
    const button = event.submitter;

    if (!(button instanceof HTMLButtonElement)) return;

    this.element.action = button.formAction;
  }
}
